import { memo } from 'react';

import { PresentationIcon } from '@air/design-icons';

/** Presentation mark for showcase entity monikers; the chip never uses a still. */
export const WorkspaceAgentShowcasePillLeadingVisual = memo(() => (
  <span
    className="flex size-[18px] shrink-0 items-center justify-center rounded-2 ads:bg-subtle bg-gray-3 ads:text-icon-default text-gray-11"
    data-testid="WORKSPACE_AGENT_MESSAGE_SHOWCASE_PILL_LEADING"
  >
    <PresentationIcon aria-hidden data-testid="WORKSPACE_AGENT_MESSAGE_SHOWCASE_PILL_ICON" size="xs" />
  </span>
));

WorkspaceAgentShowcasePillLeadingVisual.displayName = 'WorkspaceAgentShowcasePillLeadingVisual';
